import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import BusComponent from '../../../components/BusComponent';
import DealsFromSelectedList from './DealsFromSelectedList';
import DealListDropdown from './DealListDropdown';
import { saveMapDefaults } from '../../../helpers/mapDefaults';

class DealListSelector extends BusComponent {
    constructor(props, context) {
        super(props, context);

        // Restore visibility from mapInstance so the state survives legend close/reopen
        const savedVisible = props.mapInstance._dealListPinsVisible;

        this.state = {
            activeDealList: null,
            isVisible: savedVisible !== false,
        };

        this.bindGluBusEvents({
            ACTIVE_DEAL_LIST: this.onActiveDealList,
            DEAL_LISTS_LOAD_SUCCESS: this.onDealLists,
        });
    }

    componentDidMount() {
        this.emit('ACTIVE_DEAL_LIST_GET_REQUEST');
        this.emit('DEAL_LIST_PINS_VISIBILITY_UPDATE', {
            mapInstanceId: this.props.mapInstance.id,
            visible: this.state.isVisible,
        });
    }

    componentWillUnmount() {
        this.unbindGluBusEvents();
    }

    onDealLists = () => {
        this.emit('ACTIVE_DEAL_LIST_GET_REQUEST');
    };

    onActiveDealList = ({ dealList }) => {
        this.setState({ activeDealList: dealList });
    };

    toggleVisibility = () => {
        this.setState(
            prev => ({
                isVisible: !prev.isVisible,
            }),
            () => {
                // Persist to mapInstance so the state survives legend close/reopen
                this.props.mapInstance._dealListPinsVisible = this.state.isVisible;
                saveMapDefaults(this.bus, { dealPinsVisible: this.state.isVisible });
                this.emit('DEAL_LIST_PINS_VISIBILITY_UPDATE', {
                    mapInstanceId: this.props.mapInstance.id,
                    visible: this.state.isVisible,
                });
            },
        );
    };

    render() {
        const { activeDealList, isVisible } = this.state;
        const { mapInstance } = this.props;

        return (
            <div>
                <div className="map-layers-panel__popup__horizontal-divider" />

                <div className="deal-list-selector-container">
                    <DealListDropdown
                        mapInstance={mapInstance}
                        isVisible={isVisible}
                        onVisibilityToggle={this.toggleVisibility}
                    />

                    {isVisible && (
                        <DealsFromSelectedList
                            mapInstance={mapInstance}
                            activeDealList={activeDealList}
                        />
                    )}
                </div>

                <div className="map-layers-panel__popup__horizontal-divider" />
            </div>
        );
    }
}

DealListSelector.propTypes = {
    mapInstance: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
};

export default injectIntl(DealListSelector);
